export enum SailingReportRangeType {
	Voyage = "Voyage",
	Date = "Date",
	Week = "Week",
	Month = "Month"
}
